import React, { useEffect, useState } from 'react';
import { ArrowRight, PlayCircle, CheckCircle2, X } from 'lucide-react';
import ChatPreview from './ChatPreview';

const VIDEO_SRC = '/video-logo-1791518625756-2500e9e1a8fe.mp4';

export default function Hero() {
  const [videoOpen, setVideoOpen] = useState(false);

  // Close the video with Esc
  useEffect(() => {
    if (!videoOpen) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') setVideoOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [videoOpen]);

  return (
    <section id="top" className="hero">
      <div className="hero__bg" aria-hidden="true">
        <div className="hero__blob hero__blob--1" />
        <div className="hero__blob hero__blob--2" />
        <div className="hero__grid" />
      </div>

      <div className="container hero__inner">
        <div className="hero__copy reveal">
          <span className="badge">
            <span className="badge__dot" />
            AI-powered Omnichannel Agent
          </span>

          <h1 className="hero__title">
            One AI Agent.
            <br />
            <span className="gradient-text">Every channel your customers use.</span>
          </h1>

          <p className="hero__subtitle">
            AINA unifies WhatsApp, Instagram, Telegram, Facebook and Web Chat into a single
            AI-powered inbox — qualify leads, book appointments and answer questions 24/7
            with a custom-trained agent that sounds just like your brand.
          </p>

          <ul className="hero__bullets">
            <li><CheckCircle2 size={18} /> Train on your PDFs, Docs, Sheets & Drive files</li>
            <li><CheckCircle2 size={18} /> Public or private (authorised-user-only) chats</li>
            <li><CheckCircle2 size={18} /> Visual CRM, calendar booking & Google Sheets sync</li>
          </ul>

          <div className="hero__actions">
            <a href="#pricing" className="btn btn--primary btn--lg">
              See pricing
              <ArrowRight size={18} />
            </a>
            <button type="button" className="btn btn--ghost btn--lg" onClick={() => setVideoOpen(true)}>
              <PlayCircle size={20} />
              Watch the video
            </button>
          </div>

        </div>

        <div className="hero__visual reveal">
          <ChatPreview />
        </div>
      </div>

      {videoOpen && (
        <div className="videoModal" role="dialog" aria-modal="true" aria-label="AINA Suite video" onClick={() => setVideoOpen(false)}>
          <div className="videoModal__box" onClick={(e) => e.stopPropagation()}>
            <button type="button" className="videoModal__close" onClick={() => setVideoOpen(false)} aria-label="Close video">
              <X size={20} />
            </button>
            <video
              className="videoModal__video"
              src={VIDEO_SRC}
              poster="/video-logo-poster.jpg"
              controls
              autoPlay
              playsInline
            />
          </div>
        </div>
      )}
    </section>
  );
}
